import React from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import { PageUrls } from '@utils/constants/PageUrls';
import { TechnologiesProps } from './TechnologiesProps';

import * as styles from './Technologies.module.scss';

export const Technologies: React.FC<TechnologiesProps> = ({
	title,
	technologiesData,
}) => {
	return (
		<PaddingContainer className="gray-bg">
			<WidthContainer>
				<h2 className="font-size-medium-title font-600">{title}</h2>
				<div className="row no-gutters mb-4">
					{technologiesData.map((item) => (
						<div key={item.name} className="col-12 col-xl-6">
							<h3 className="font-size-22 font-600 mt-4 mb-2">{item.name}</h3>
							<div
								className={classNames(styles.technologies, 'd-flex flex-wrap')}
							>
								{item.technologies.map((technology) => (
									<div key={technology.name} className={styles.technology}>
										<img src={technology.icon} />
										<p>{technology.name}</p>
									</div>
								))}
							</div>
						</div>
					))}
				</div>
				<div className="d-flex flex-column align-items-center mt-3">
					<p className="font-size-sm mb-3">
						Are you looking for other technologies? Contact us anyway.
					</p>
					<Link to={PageUrls.CONTACT}>
						<button
							className={classNames(styles.link, 'bttn bttn-orange-border')}
						>
							CONTACT US
						</button>
					</Link>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
